import {
  ChangeDetectionStrategy,
  Component
} from '@angular/core';

import { FsBadgeModule } from '@firestitch/badge';


@Component({
  selector: 'app-indicator',
  templateUrl: './indicator.component.html',
  styleUrls: ['./indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FsBadgeModule,
  ],
})
export class IndicatorComponent {

}
